import ComponentModule from "@eisinc/Overrides/Components/ProductAvailability";

export * from "@eisinc/Overrides/Components/ProductAvailability";

export default ComponentModule;
